import { Component, Input, SimpleChanges } from '@angular/core';
import { UnaryFunction } from '@dice/app/types/dice.types';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'table-column-switch',
  templateUrl: './table-column-switch.component.html',
  standalone: false,
})
export class TableColumnSwitchComponent<T> {
  @Input() element: T;

  @Input() checked: UnaryFunction<T, boolean> | boolean;

  @Input() onClick: UnaryFunction<T>;

  @Input() disabled: UnaryFunction<T, boolean> | boolean;

  @Input() id: number | string = Math.floor(Math.random() * 10000 + moment().unix());

  static readonly sortEnabled = false;

  readonly isChecked$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  readonly isDisabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.element) {
      this.evaluateState();
    }
  }

  clickHandler(event: Event): void {
    if (this.onClick && typeof this.onClick === 'function') {
      this.onClick(this.element);
    }
  }

  private evaluateState(): void {
    if (this.element) {
      if (this.checked != null) {
        if (typeof this.checked === 'function') {
          this.isChecked$.next(this.checked(this.element));
        } else if (typeof this.checked === 'boolean') {
          this.isChecked$.next(this.checked);
        }
      }
      if (this.disabled != null) {
        if (typeof this.disabled === 'function') {
          this.isDisabled$.next(this.disabled(this.element));
        } else if (typeof this.disabled === 'boolean') {
          this.isDisabled$.next(this.disabled);
        }
      }
    }
  }
}
